module.exports = __webpack_public_path__ + "static/media/fanTan_mobileCasino_gameicon_174x174_en.d99e0a68.png";